import { ProductPartnership } from "@/shared/enums/product-partnership.enum";
import { StorePartnershipMutations } from "@/shared/models/store-partnership.model";

const mutations: StorePartnershipMutations = {
  setClaim(state, claim) {
    state.claim = claim;
  },

  setClaimHistory(state, claimHistory) {
    state.claimHistory = claimHistory;
  },

  setClaimList(state, payload) {
    const { data, tab } = payload as Record<string, any>;

    if (typeof tab === "undefined" && tab === null) {
      state.claims = payload;
    } else {
      state.claims[tab] = data;
    }
  },

  setClaimListMeta(state, claimsMeta) {
    state.claimsMeta = claimsMeta;
  },

  setPolicy(state, policy) {
    state.policy = policy;
  },

  setPolicyList(state, payload) {
    const { data, tab } = payload as Record<string, any>;

    if (typeof tab === "undefined" && tab === null) {
      state.policies = payload;
    } else {
      state.policies[tab] = data;
    }
  },

  setPolicyListMeta(state, policiesMeta) {
    state.policiesMeta = policiesMeta;
  },

  setPartnerList(state, partners) {
    state.partners = partners;
  },

  setUploadProgress(state, uploadProgress) {
    state.uploadProgress = uploadProgress;
  },

  setProduct(state, product) {
    state.product = product;
  },

  setProductList(state, productList) {
    const availableProducts = [
      ProductPartnership.Gadget,
      ProductPartnership.Finance,
      ProductPartnership.MicroHealth,
      ProductPartnership.Travel,
      ProductPartnership.Logistic,
      ProductPartnership.Vehicle,
      ProductPartnership.Goods,
    ];

    const validProducts = productList.filter((product) => {
      return availableProducts.includes(product.productCategorySlug);
    });

    const microhealthProduct = validProducts.filter((product) => {
      return product.productCategorySlug === ProductPartnership.MicroHealth;
    });

    const allProd = validProducts.filter((product) => {
      return product.productCategorySlug !== ProductPartnership.MicroHealth;
    });
    state.productList = microhealthProduct.concat(allProd);
  },

  setInvoiceList(state, payload) {
    const { data, tab } = payload as Record<string, any>;

    if (typeof tab === "undefined" && tab === null) {
      state.invoices = payload;
    } else {
      state.invoices[tab] = data;
    }
  },

  setInvoiceListMeta(state, invoicesMeta) {
    state.invoicesMeta = invoicesMeta;
  },

  setInvoiceHistory(state, claimHistory) {
    state.invoiceHistory = claimHistory;
  },

  setClaimDisbursementList(state, payload) {
    const { data, tab } = payload as Record<string, any>;

    if (typeof tab === "undefined" && tab === null) {
      state.claimsDisbursement = payload;
    } else {
      state.claimsDisbursement[tab] = data;
    }
  },

  setClaimDisbursementListMeta(state, claimsDisbursementMeta) {
    state.claimsDisbursementMeta = claimsDisbursementMeta;
  },

  setClaimDisbursementDetail(state, claimDisbursementDetail) {
    state.claimDisbursementDetail = claimDisbursementDetail;
  },

  setClaimDisbursementHistory(state, claimDisbursementHistory) {
    state.claimDisbursementHistory = claimDisbursementHistory;
  },

  setInvoice(state, invoice) {
    state.invoice = invoice;
  },

  setClaimPoolList(state, payload) {
    const { data, tab } = payload as Record<string, any>;

    if (typeof tab === "undefined" && tab === null) {
      state.claimPools = payload;
    } else {
      state.claimPools[tab] = data;
    }
  },

  setClaimPoolListMeta(state, claimPoolsMeta) {
    state.claimPoolsMeta = claimPoolsMeta;
  },

  setClaimPool(state, claimPool) {
    state.claimPool = claimPool;
  },

  mutationGadgets(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.gadgets[payload.tab] = payload.responseData;
    } else {
      state.gadgets.push(payload);
    }
  },

  mutationGadgetsMeta(state, payload) {
    state.gadgetsMeta = payload;
  },

  // this is for lazy loading
  mutationGadgetsAll(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null && payload.responseData) {
      payload.responseData.forEach((item) => {
        if (typeof state.gadgetsAll[payload.tab] === "undefined") {
          state.gadgetsAll[payload.tab] = [];
        } 
        
        state.gadgetsAll[payload.tab] = item;
      });
    } else if (!payload.length) {
      state.gadgetsAll = [];
    } else {
      payload.forEach((item) => {
        state.gadgetsAll.push(item);
      });
    }
  },

  mutationGadgetCategory(state, payload) {
    state.gadgetCategory = payload;
  },
  mutationListBrand(state, payload) {
    state.listBrand = payload;
  },
};

export default mutations;
